module.exports = __webpack_public_path__ + "static/media/activity-not-proceeding.0e88cc9f.svg";